// extracted by mini-css-extract-plugin
export default {"root":"IconEdit_root__fCz2s","pencil":"IconEdit_pencil__SxkMG"};